import { render } from "./RegisterToolTip.vue?vue&type=template&id=5f822b44&scoped=true"
import script from "./RegisterToolTip.vue?vue&type=script&lang=js"
export * from "./RegisterToolTip.vue?vue&type=script&lang=js"

import "./RegisterToolTip.vue?vue&type=style&index=0&id=5f822b44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f822b44"]])

export default __exports__